import { GridColDef } from "@mui/x-data-grid";
import { AppTable } from "components/molecules";
import { TableHelper } from "helpers";
import { usePaginationRequest } from "hooks";
import { IGetPeriodCycleCountDetailRequest, ILoadingOrderPallet } from "model";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { LoadingOrderActions } from "redux/actions";
import { useAppSelector } from "redux/configurations/reduxHooks";
import { CycleCountApiService } from "services";
import { CURRENT_PAGE_SIZE, FIRST_PAGE } from "utils/Const";
import { I18nTranslator, translations } from "utils/i18n";

interface IProductListProps {
  id: string;
}
const ConfirmLocationList = (props: IProductListProps) => {
  const { id } = props;
  const action = useAppSelector(
    (state) => state.LoadingOrderReducer.pallet.action
  );

  const [refresh, setRefresh] = useState(false);

  const [request, setRequest] = useState<IGetPeriodCycleCountDetailRequest>({
    documentNbr: "",
    cycleCountPeriodID: id,
    pageNumber: FIRST_PAGE,
    pageSize: CURRENT_PAGE_SIZE,
  });

  const { loading, result } = usePaginationRequest<
    IGetPeriodCycleCountDetailRequest,
    any[]
  >(
    request,
    CycleCountApiService.getPeriodicCycleCountDetailSplit,
    [],
    {
      refresh: refresh,
    },
    () => {
      setRefresh(false);
    }
  );

  const _handleChangePage = (pageNumber: number) => {
    setRequest({
      ...request,
      pageNumber,
    });
  };

  const _handleSearch = (searchText: string) => {
    setRequest({
      ...request,
      searchText,
    });
  };

  const _handlePageSizeChange = (pageSize: number) => {
    setRequest({ ...request, pageSize: pageSize });
  };
  const COLUMNS: GridColDef[] = [
    TableHelper.renderSTT(),
    TableHelper.createCell({
      field: "zoneName",
      headerName: I18nTranslator(translations.masterData.zoneName),
      size: "small",
      align: "left",
    }),
    TableHelper.createCell({
      field: "locationName",
      headerName: I18nTranslator(translations.masterData.locationName),
      size: "small",
      align: "left",
    }),

    TableHelper.createCell({
      field: "palletCode",
      headerName: I18nTranslator(translations.receive.palletCode),
      size: "small",
      align: "left",
    }),
    TableHelper.createCell({
      field: "productLot",
      headerName: I18nTranslator(translations.receive.productLot),
      size: "small",
      align: "right",
    }),
    TableHelper.createCell({
      field: "productCode",
      headerName: I18nTranslator(translations.receive.productCode),
      size: "small",
      align: "left",
    }),
    TableHelper.createCell({
      field: "productDescription",
      headerName: I18nTranslator(translations.receive.productName),
      size: "full",
      align: "left",
    }),
    TableHelper.createCell({
      field: "actualQuantity",
      headerName: "Actual quantity",
      size: "small",
      align: "left",
    }),
    TableHelper.createCell({
      field: "verifyQuantity",
      headerName: "Checked quantity",
      size: "small",
      align: "right",
    }),
    TableHelper.createCell({
      field: "verifyQuantity",
      headerName: "Confirmed quantity",
      size: "small",
      align: "right",
    }),
    TableHelper.createCell({
      field: "note",
      headerName: "Note",
      size: "small",
      align: "left",
    }),
  ];
  return (
    <AppTable<any>
      loading={action.includes(
        LoadingOrderActions.getAllLoadingOrderProducts.requestName
      )}
      data={result}
      columns={COLUMNS}
      hideAddNew
      onSearch={_handleSearch}
      searchPlaceholder={I18nTranslator(
        translations.placeholder.searchLoadingOrderPallet
      )}
      removeActionColumn
      hideHeader
      defaultHeaderTable={230}
      onChangePage={_handleChangePage}
      onPageSizeChange={_handlePageSizeChange}
    />
  );
};

export default ConfirmLocationList;
